<template>
  <div class="pagina">
    <!-- Header -->
    <header class="header">
      <img src="/img/logo-preta.png" height="36" alt="Bike Registrada" />
    </header>

    <!-- Steps -->
    <RegistroBikeStepper :current-step="0" :steps="['Dados pessoais', 'Tipos de registro', 'Finalização']" />

    <!-- Conteúdo -->
    <div class="conteudo">
      <div class="card-form">
        <h2 class="titulo">Bem-vindo (a) a criação de Registro da <strong>Bike Registrada</strong></h2>

        <div class="campo">
          <label class="campo-label">Qual é o seu nome completo?</label>
          <input
            v-model="nome"
            type="text"
            class="campo-input"
            :class="{ 'campo-input--erro': nomeError }"
            placeholder="Informe seu nome e sobrenome"
            autocomplete="off"
            @input="nomeError = ''"
          />
          <span v-if="nomeError" class="campo-erro">{{ nomeError }}</span>
        </div>

        <div class="rodape-form">
          <button
            class="btn-continuar"
            :disabled="!nome || !nome.trim()"
            @click="continuar"
          >
            Continuar
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform:scaleX(-1)"><path d="M12.5017 6.66829H0.835041M0.835041 6.66829L6.66837 0.834961M0.835041 6.66829L6.66837 12.5016" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer">
      <span>Copyright © 2025 Bike Registrada Online LTDA.</span>
      <div class="footer-contatos">
        <span>Contatos:</span>
        <a href="https://wa.me/556135224521" target="_blank" rel="noopener">
          <i class="fab fa-whatsapp"></i> (61) 3522-4521
        </a>
        <a href="mailto:seguro@bikeregistrada.com.br">
          <i class="far fa-envelope"></i> seguro@bikeregistrada.com.br
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import RegistroBikeStepper from "@/components/RegistroBikeStepper.vue";
import validacaoNomeCompleto from "@/helpers/validacaoNomeCompleto";

export default {
  name: "DadosEssenciais",
  components: { RegistroBikeStepper },
  data() {
    return {
      nome: "",
      nomeError: "",
    };
  },
  created() {
    this.nome = sessionStorage.getItem("registro_nome") || "";
  },
  methods: {
    continuar() {
      if (!this.nome || !this.nome.trim()) return;
      const resultado = validacaoNomeCompleto(this.nome);
      if (resultado !== true) {
        this.nomeError = resultado || "Digite seu nome completo";
        return;
      }
      sessionStorage.setItem("registro_nome", this.nome.trim());
      this.$router.push({ name: "registro-bike-contato" });
    },
  },
};
</script>

<style scoped>
.pagina {
  min-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f9f9f9;
  background-image: url(/img/bike-mundo.svg);
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 35%;
  font-family: Inter !important;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Header */
.header {
  padding: 16px 32px;
  padding-top: calc(16px + env(safe-area-inset-top));
  background: #f9f9f9;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 10;
}

/* Conteúdo */
.conteudo {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 40px 16px;
  position: relative;
  z-index: 10;
}

.card-form {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  padding: 40px 48px;
  width: 100%;
  max-width: 652px;
}

.titulo {
  font-size: 22px;
  font-weight: 700;
  color: #4FA935;
  line-height: 1.35;
  margin-bottom: 28px;
}

.campo {
  margin-bottom: 24px;
}

.campo-label {
  display: block;
  font-size: 14px;
  color: #64748B;
  margin-bottom: 8px;
}

.campo-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  font-size: 15px;
  color: #333;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.campo-input:focus {
  border-color: #4FA935;
}

.campo-input::placeholder {
  color: #CBD5E1;
}

.campo-input--erro {
  border-color: #e53935 !important;
}

.campo-erro {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #e53935;
}

.rodape-form {
  display: flex;
  justify-content: flex-end;
  margin-top: 48px;
}

.btn-continuar {
  background: #4b9c2e;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 0.2s;
}

.btn-continuar:hover:not(:disabled) {
  background: #3d8224;
}

.btn-continuar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.seta {
  font-size: 16px;
}

/* Footer */
.footer {
  padding: 14px 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #64748B;
  position: relative;
  z-index: 10;
}

.footer-contatos {
  display: flex;
  align-items: center;
  gap: 20px;
}

.footer-contatos a {
  color: #4FA935;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.footer-contatos a:hover {
  color: #4FA935;
}

@media (max-width: 600px) {
  .stepper {
    display: none;
  }

  .pagina {
    background-size: 75%;
  }

  .conteudo {
    padding: 24px 16px;
    align-items: flex-start;
  }

  .card-form {
    padding: 28px 20px;
  }

  .titulo {
    font-size: 26px;
  }

  .footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 14px 20px;
    font-size: 10px;
    color: #64748B;
    text-align: left;
  }

  .imagem-ciclista {
    display: none;
  }

  .header {
    background: #fff;
    border-bottom: 1px solid #E2E8F0;
  }
}
</style>
